export default function (err) {
  console.log("received socket error:", err);
}
